/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface SaveLicenseFeatures$Request {
    licenseId: number;
    requestBody: Array<string>;
}

export interface SaveLicenseFeatures$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveLicenseFeaturesRequest = createAction<PayloadData<void, SaveLicenseFeatures$Request>>('SAVE_LICENSE_AVAILABLE_FEATURES__SAVE_LICENSE_FEATURES__REQUEST');
export const saveLicenseFeaturesSuccess = createAction<PayloadData<void, SaveLicenseFeatures$Request>>('SAVE_LICENSE_AVAILABLE_FEATURES__SAVE_LICENSE_FEATURES__SUCCESS');
export const saveLicenseFeaturesFailure = createAction<PayloadData<Error, SaveLicenseFeatures$Request, true>>('SAVE_LICENSE_AVAILABLE_FEATURES__SAVE_LICENSE_FEATURES__FAILURE');

export const saveLicenseFeaturesActions = [
    saveLicenseFeaturesRequest,
    saveLicenseFeaturesSuccess,
    saveLicenseFeaturesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveLicenseFeatures = (meta: SaveLicenseFeatures$Request, config?: SaveLicenseFeatures$Config) => {
    return {
        CALL_API: {
            types: saveLicenseFeaturesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/licenses/${meta.licenseId}/available-features`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

